enum CompanyType {
  CONSTRUCTION = '0',
  INTERIOR_DESIGN = '1',
  MANUFACTURING = '2',
  FASHION = '3',
  OTHER = '4'
}

export default CompanyType
